import { CompletionCriterion } from "../Course/types";
import { AlternativeLOSection, SelectedLOItem } from "../types";

export const requiresMandatoryLOs = (
  criterion: CompletionCriterion | null,
): boolean => criterion === "LO_REQUIRED";

/** Dissolve alternative groups without losing their contents or removal locks. */
export const normalizeCompletionItems = <TItem extends SelectedLOItem>(
  items: Array<TItem | AlternativeLOSection<TItem>>,
  criterion: CompletionCriterion | null,
): Array<TItem | AlternativeLOSection<TItem>> => {
  if (requiresMandatoryLOs(criterion)) return items;

  return items.flatMap((item) => {
    if (item.kind !== "section") {
      return [{ ...item, completion_criteria: null }];
    }

    return item.items.map((child) => ({
      ...child,
      ...(item.locked ? { locked: true } : {}),
      completion_criteria: null,
    }));
  });
};
